const taskStatus = {
  JOBSLIPTASK: 'JOBSLIPTASK',
  OVERDUETASK: 'OVERDUETASK',
  INSPECTION: 'INSPECTION',
  DEPARTMENTWISEKANBAN: 'DEPARTMENTWISEKANBAN',
  MACHINEWISEKANBAN: 'MACHINEWISEKANBAN'
}

export { taskStatus }
